import SearchOutlined from '@mui/icons-material/SearchOutlined';
import { Box, InputAdornment, TextField } from '@mui/material';
import SelectBase from 'components/forms/fields/select-field/select-base/select-base.component';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useCategorySearchParam,
  useSearchParamsContext,
} from '../search.hooks';

export type CategorySearchInputProps = {
  InputProps?: object;
};

const CategorySearchInput = ({
  InputProps = {},
  ...rest
}: CategorySearchInputProps) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>();

  const context = useSearchParamsContext();
  const options = Object.values(context.categories).map(category => ({
    id: category.paramName,
    label: category.category,
  }));

  const [categoryId, setCategoryId] = useState('');
  const { value, setValue, reset, searchParam } =
    useCategorySearchParam(categoryId);

  return (
    <Box display="flex">
      <SelectBase
        options={options}
        value={searchParam?.paramName}
        onChange={event => {
          reset();
          inputRef.current.value = '';
          setCategoryId(event.target.value);
          setTimeout(() => {
            inputRef.current?.focus();
          }, 0);
        }}
        fullWidth={false}
        sx={{
          '&&': {
            '& fieldset, .MuiInputBase-root': {
              borderRadius: '4px 0 0 4px',
            },
            m: 0,
          },
        }}
        data-testid="CategorySearchInput.Select"
      />
      <TextField
        fullWidth={false}
        defaultValue={value}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlined />
            </InputAdornment>
          ),
          ...InputProps,
        }}
        onKeyUp={e => {
          if (e.key === 'Enter') {
            setValue(inputRef.current.value);
          }
        }}
        inputRef={inputRef}
        data-testid="SearchInput"
        sx={{
          '&&': {
            flex: 1,
            m: 0,
            '& fieldset, .MuiInputBase-root': {
              borderRadius: '0 4px 4px 0',
            },
          },
        }}
        placeholder={t(
          'SearchDataGrid.searchToolbar.categorySearchInput.label',
          {
            category: searchParam?.category,
          },
        )}
        {...rest}
      />
    </Box>
  );
};

export default CategorySearchInput;
